module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_03@2x-37040ad0694d76264d80f3a59244b26d.webp";